/* ============================================
   VELLANAR — Scripts (vl-scripts.js)
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initFAQ();
  initComparador();
  initGaleria();
  initBtnRipple();
  initFAB();
  initStatCounter();
  initTestiCarousel();
});
if (document.readyState === 'interactive' || document.readyState === 'complete') {
  initFAQ();
}

/* — Reveal al hacer scroll (up + left + right + scale) —— */
function initReveal() {
  var sel = '.vl-reveal, .vl-reveal--left, .vl-reveal--right, .vl-reveal--scale';
  var els = document.querySelectorAll(sel);
  if (!els.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('vl-visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  els.forEach(function (el) { obs.observe(el); });
}

/* — FAQ accordion ——————————————————————————— */
function initFAQ() {
  var items = document.querySelectorAll('.vl-faq__item:not([data-faq-init])');
  if (!items.length) return;
  items.forEach(function (item) {
    item.setAttribute('data-faq-init', '1');
    var btn  = item.querySelector('.vl-faq__btn');
    var body = item.querySelector('.vl-faq__body');
    if (!btn || !body) return;
    btn.addEventListener('click', function () {
      var allItems = document.querySelectorAll('.vl-faq__item');
      var isOpen = item.classList.contains('vl-open');
      allItems.forEach(function (i) {
        i.classList.remove('vl-open');
        var b = i.querySelector('.vl-faq__body');
        if (b) b.style.maxHeight = '0';
      });
      if (!isOpen) {
        item.classList.add('vl-open');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });
}

/* — Comparador antes/después ————————————————— */
function initComparador() {
  var slider = document.querySelector('.vl-slider');
  if (!slider) return;
  var afterImg = slider.querySelector('.vl-slider__after img');
  var handle   = slider.querySelector('.vl-slider__handle');
  var line     = slider.querySelector('.vl-slider__line');
  if (!afterImg || !handle || !line) return;
  var dragging = false;

  function setPos(clientX) {
    var rect = slider.getBoundingClientRect();
    var pct  = Math.max(0.04, Math.min(0.96, (clientX - rect.left) / rect.width));
    var pStr = (pct * 100).toFixed(1) + '%';
    afterImg.style.clipPath = 'inset(0 ' + ((1 - pct) * 100).toFixed(1) + '% 0 0)';
    handle.style.left = pStr;
    line.style.left   = pStr;
  }

  handle.addEventListener('mousedown',  function (e) { dragging = true; e.preventDefault(); });
  document.addEventListener('mousemove', function (e) { if (dragging) setPos(e.clientX); });
  document.addEventListener('mouseup',   function ()  { dragging = false; });
  handle.addEventListener('touchstart',  function (e) { dragging = true; e.preventDefault(); }, { passive: false });
  document.addEventListener('touchmove', function (e) { if (dragging) setPos(e.touches[0].clientX); }, { passive: true });
  document.addEventListener('touchend',  function ()  { dragging = false; });

  var r = slider.getBoundingClientRect();
  setPos(r.left + r.width * 0.5);
}

/* — Galería de producto ————————————————————— */
function initGaleria() {
  var thumbs    = document.querySelectorAll('.vl-galeria__thumb');
  var principal = document.querySelector('.vl-galeria__main img');
  if (!thumbs.length || !principal) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('vl-active'); });
      thumb.classList.add('vl-active');
      principal.src = thumb.querySelector('img').src;
    });
  });
}

/* — Ripple en botones ——————————————————————— */
function initBtnRipple() {
  document.querySelectorAll('.vl-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var rect   = btn.getBoundingClientRect();
      var x      = e.clientX - rect.left;
      var y      = e.clientY - rect.top;
      var ripple = document.createElement('span');
      ripple.className  = 'vl-ripple';
      ripple.style.left = x + 'px';
      ripple.style.top  = y + 'px';
      btn.appendChild(ripple);
      setTimeout(function () { ripple.remove(); }, 700);
    });
  });
}

/* — Contador animado de estadísticas ————————— */
function initStatCounter() {
  var els = document.querySelectorAll('.vl-stat__num');
  if (!els.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      obs.unobserve(e.target);
      var el   = e.target;
      var orig = el.textContent.trim();
      var m    = orig.match(/^(\d[\d.]*\d|\d+)/);
      if (!m) return;
      var num = parseFloat(m[1].replace(/\./g, ''));
      if (isNaN(num) || num < 1000) return;
      var suffix    = orig.slice(m[0].length);
      var startTime = null;
      var dur       = 1400;
      function fmt(n) {
        return n >= 1000
          ? Math.floor(n / 1000) + '.' + String(n % 1000).padStart(3, '0')
          : String(n);
      }
      function frame(ts) {
        if (!startTime) startTime = ts;
        var p     = Math.min((ts - startTime) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(Math.round(num * eased)) + suffix;
        if (p < 1) requestAnimationFrame(frame);
        else el.textContent = orig;
      }
      requestAnimationFrame(frame);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { obs.observe(el); });
}

/* — Botón flotante (FAB) ——————————————————— */
function initFAB() {
  var fab     = document.getElementById('vl-fab');
  var trigger = document.querySelector('.vl-hero__ctas');
  if (!fab || !trigger) return;

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      fab.classList.toggle('vl-fab--on', !e.isIntersecting);
    });
  }, { threshold: 0 });
  obs.observe(trigger);
}

/* — Carrusel de testimonios ————————————————— */
function initTestiCarousel() {
  document.querySelectorAll('.vl-testi-carousel').forEach(function (carousel) {
    var track = carousel.querySelector('.vl-testi-track');
    var prev  = carousel.querySelector('.vl-testi-nav--prev');
    var next  = carousel.querySelector('.vl-testi-nav--next');
    if (!track || !prev || !next) return;

    function step() {
      var card = track.querySelector('.vl-testi');
      if (!card) return track.clientWidth * 0.9;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 20);
      return card.getBoundingClientRect().width + gap;
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });
}
